import { patientOverviewItemsQueryKey } from '@onestep/camel-api/hooks';
import type { QueryClient } from '@tanstack/react-query';

export const invalidatePatientOverviewData = (queryClient: QueryClient, patientUuid: string) =>
  Promise.all([
    queryClient.invalidateQueries({ queryKey: ['camel', 'patients', patientUuid, 'gait'] }),
    queryClient.invalidateQueries({ queryKey: patientOverviewItemsQueryKey(patientUuid) }),
  ]);
